export enum CalendarGridCurrentTimeIndicatorCssVars {
  yPosition = '--y-position',
}
